import type { FC } from "react";

export const EmailDesktopPreivew: FC<{ data: string }> = ({ data }) => {
  return (
    <iframe
      sandbox="allow-popups allow-popups-to-escape-sandbox"
      srcDoc={data}
      style={{ width: "100%", height: "100%" }}
      title="ChangeEngine Email Preview"
      role="document"
      data-testid="preview-email-iframe"
    />
  );
};
